import { createSelector } from '@reduxjs/toolkit';
import {
  getFromImmutableStateCompatible,
  getImmutableCompatible,
} from 'src/utils/immutableUtils';
import type { TravelRequirementsState } from './types';

const _getTravelRequirements = (state) =>
  getImmutableCompatible(state, 'travelRequirements');

const getTravelRequirements =
  getFromImmutableStateCompatible<TravelRequirementsState>(
    _getTravelRequirements,
  );

export const getDataFromTravelRequirements = createSelector(
  [getTravelRequirements],
  (travelRequirements: TravelRequirementsState) => travelRequirements,
);
